<template>
  <n-config-provider
    :theme-overrides="themeOverrides"
    :locale="enUS"
    :date-locale="dateEnUS"
    :breakpoints="{ xs: 0, s: 500, m: 700, l: 1200, xl: 1440, xxl: 1920 }"
  >
    <n-message-provider placement="bottom">
      <router-view />
      <n-global-style />
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import {
  NConfigProvider,
  GlobalThemeOverrides,
  NGlobalStyle,
  NMessageProvider,
  enUS,
  dateEnUS,
} from 'naive-ui'

const themeOverrides: GlobalThemeOverrides = {
  common: {
    heightMedium: '40px',
    fontWeightStrong: '700',
    borderRadius: '10px',
    fontSize: '16px',
    primaryColor: '#00C2FFFF',
    primaryColorHover: '#52D6FFFF',
    primaryColorPressed: '#0097C7FF',
    primaryColorSuppl: '#006D8FFF',
    successColor: '#00FF57FF',
    errorColor: '#FF0000FF',
    successColorHover: '#29FF72FF',
    successColorPressed: '#00C744FF',
    successColorSuppl: '#008F31FF',
    infoColor: '#7BBC2FFF',
    infoColorHover: '#A3D864FF',
    infoColorPressed: '#5E8F24FF',
    infoColorSuppl: '#406219FF',
    errorColorHover: '#FF5252FF',
    errorColorPressed: '#C70000FF',
    errorColorSuppl: '#8F0000FF',
    warningColor: '#00C2FFCC',
    warningColorHover: '#00C2FFFF',
  },
  Button: {
    borderRadiusMedium: '50px',
    fontWeight: '700',
    paddingMedium: '1rem 2rem',
    textColor: '#FFFFFF',
  },
  Card: {
    color: '#1A1D1F',
    borderColor: 'transparent',
  },

  Divider: {
    color: '#1A1D1F',
  },

  Input: {
    color: '#0E0E0E',
    paddingMedium: '1rem',
    groupLabelColor: '#161616',
    groupLabelTextColor: '#858585',
  },
  List: {
    color: 'transparent',
    borderColor: '#858585',
  },
  Collapse: {
    titleFontSize: '16px',
    titleFontWeight: '700',
    dividerColor: '#858585FF',
    titleTextColor: '#858585FF',
  },
  Slider: {
    fillColor: '#4C4C4C',
    fillColorHover: '#000000',
  },
  Form: {
    feedbackHeightLarge: '12px',
    feedbackHeightMedium: '8px',
    feedbackHeightSmall: '4px',
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@400;700&family=Roboto:wght@400;500;700&display=swap');

* {
  box-sizing: border-box;
}

body {
  font-family: 'Roboto', sans-serif;
  height: 100%;
  overflow: hidden;
}

html {
  height: 100%;
  font-size: 62.5%;
}

#app {
  height: 100%;
}

.n-config-provider {
  height: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6,
.n-h,
label {
  margin-top: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-family: 'Roboto Condensed', sans-serif;
}

p {
  margin-top: 0;
}

.n-list .n-list-item {
  align-items: start;

  .n-list-item__main {
    flex: 1 0 auto;

    h5 {
      margin-bottom: 0;
      font-size: 1rem;
      color: #858585;
    }
  }
}

.n-collapse .n-collapse-item:not(:first-child) {
  border-width: 2px;
}

::-webkit-scrollbar {
  height: 8px;
  width: 8px;
  background: transparent;
}

::-webkit-scrollbar-track:horizontal {
  border-radius: 10px;
  background: #858585;
}

::-webkit-scrollbar-thumb:horizontal {
  border-radius: 10px;
  background: #ffffff;
}
</style>
